import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Slide from '@material-ui/core/Slide';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Button from 'components/CustomButtons/Button.jsx';
import style from 'assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.jsx';
import basicsStyle from 'assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.jsx';
import javascriptstyles from 'assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.jsx';
import CircularProgress from '@material-ui/core/CircularProgress';
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import { getAllSprintList, updateSprint } from '../../../actions/sprint';
import {
  deleteUserStory,
  getUserStories,
  moveUserStoryToAnotherSprint,
  setUserStoriesData,
} from '../../../actions/userStories';
import _ from 'lodash-es';
import ReactHtmlParser from 'react-html-parser';
import { Grid } from '@material-ui/core';

function Transition(props) {
  return <Slide direction='down' {...props} />;
}

class SprintInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fourthStep: 'fourth step here',
      classicModal: false,
      isLoading: false,
      sprintLists: [],
      moveStory: '',
      storyData: {},
      userStoriesSavedData: [],
      projectId: '',
      sprintId: '',
    };
    this.handleToggle = this.handleToggle.bind(this);
  }

  async componentWillMount() {
    const { project, sprint } = this.props;
    const responses = await this.props.getUserStories(project._id, sprint._id);
    if (responses.success === true) {
      this.setState({ userStoriesSavedData: responses && responses.data });
    }
  }

  sendData = (project, sprintSavedData) => {
    const { history } = this.props;
    history.push({
      pathname: `/project/${sprintSavedData}/sprint/status`,
      state: {
        projectId: project,
        sprintId: sprintSavedData,
      },
    });
  };

  onSubmitSprint = async () => {
    this.setState({ isLoading: true });
    const { project, sprint } = this.props;
    const data = {
      isSubmitted: true,
    };
    const response = await this.props.updateSprint(
      data,
      project._id,
      sprint._id
    );
    if (response && response.data) {
      this.setState({ isLoading: false });
      this.sendData(project._id, sprint._id);
    }
  };

  moveSprint = async () => {
    const { moveStory, storyData } = this.state;
    const response = await this.props.moveUserStoryToAnotherSprint(
      storyData.project,
      storyData.sprint,
      storyData._id,
      moveStory
    );
    if (response && response.data) {
      const responses = await this.props.getUserStories(
        storyData.project,
        storyData.sprint
      );
      if (responses.success === true) {
        this.setState({ userStoriesSavedData: responses && responses.data });
      }
      this.handleClose('classicModal');
      this.props.setUserStoriesData(this.props.userStoriesList);
    }
  };

  handleToggle(value) {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked,
    });
  }

  handleClickOpen = async (modal, val) => {
    var x = [];
    x[modal] = true;
    this.setState(x);
    const response = await this.props.loadSprintLists(val.project);
    if (response && response.data) {
      const filteredIsSubmitted =
        response &&
        response.data.filter(
          (item) =>
            !item.isSubmitted &&
            item.sprintStatus.status !== 'In Progress' &&
            item._id !== val.sprint
        );
      this.setState({
        sprintLists: filteredIsSubmitted,
      });
    }
    this.setState({ storyData: val });
  };

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onDelete = async (projectId, sprintId, storyId) => {
    try {
      const response = await this.props.deleteUserStory(
        projectId,
        sprintId,
        storyId
      );
      if (response && response.data) {
        const response = await this.props.getUserStories(projectId, sprintId);
        if (response.success === true) {
          this.setState({ userStoriesSavedData: response && response.data });
        }
      }
    } catch (er) {
      if (er.response) {
        this.setState({
          message: er.response.data.errorMessage,
        });
      }
    }
  };

  confirmDeleteUserStory = (projectId, sprintId, storyId) => {
    confirmAlert({
      title: 'Are you sure ?',
      message: 'Are you sure want to delete  this user Story?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.onDelete(projectId, sprintId, storyId),
          className: 'Sonu',
        },
        {
          label: 'No',
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    const { isLoading, sprintLists, moveStory } = this.state;
    return (
      <div>
        <div className='review-section'>
          {isLoading && <CircularProgress />}
          <div className='title-section'>
            <h5>Project Information:</h5>
            <Link to={`/projects/${this.props.project._id}/edit`}>
              {'Edit'}
            </Link>
          </div>
          {this.props.project && (
            <div className='info-section'>
              <p>
                <strong>Project Name: </strong> {this.props.project.title}{' '}
              </p>
              <p>
                <strong>Project Description: </strong>{' '}
                {ReactHtmlParser(this.props.project.description)}{' '}
              </p>
            </div>
          )}
          <hr />
        </div>
        <div className='review-section'>
          <div className='title-section'>
            <h5>Sprint Information:</h5>
            <Link
              to={`/projects/${this.props.project._id}/sprints/${
                this.props.sprint._id
              }/edit`}
            >
              {'Edit'}
            </Link>
          </div>
          {this.props.sprint && (
            <div className='info-section'>
              <p>
                <strong>Sprint Title: </strong> {this.props.sprint.title}{' '}
              </p>
            </div>
          )}
          <hr />
        </div>
        <div className='review-section'>
          <div className='title-section'>
            <h5>User Stories:</h5>
            <Link
              to={{
                pathname: `/projects/${this.props.project._id}/sprints/${
                  this.props.sprint._id
                }/create-story`,
                state: {
                  from: 'Review',
                },
              }}
            >
              {'Add'}
            </Link>
          </div>
          {_.map(this.state.userStoriesSavedData, (val, i) => {
            return (
              <div className='user=info-section' key={i}>
                <div className='info-section'>
                  <div className='user-stories-title-section'>
                    <p>
                      <strong>
                        Story {i + 1}/{this.state.userStoriesSavedData.length}:{' '}
                      </strong>{' '}
                      {val.title}
                    </p>
                    <div className='user-stories-actions'>
                      <Link
                        to={{
                          pathname: `/projects/${
                            this.props.project._id
                          }/sprints/${this.props.sprint._id}/stories/${
                            val._id
                          }`,
                          state: {
                            from: 'Review',
                          },
                        }}
                      >
                        {'Edit'}
                      </Link>
                      <a
                        href='#'
                        onClick={() =>
                          this.confirmDeleteUserStory(
                            val.project,
                            val.sprint,
                            val._id
                          )
                        }
                      >
                        {'Delete'}
                      </a>
                      <a
                        href='#'
                        onClick={() =>
                          this.handleClickOpen('classicModal', val)
                        }
                      >
                        {'Move Story'}
                      </a>
                      <GridContainer>
                        <GridItem xs={12} sm={6} md={6} lg={4}>
                          <Dialog
                            javascriptstyles={{
                              root: javascriptstyles.modalRoot,
                              paper: javascriptstyles.modal,
                            }}
                            open={this.state.classicModal}
                            TransitionComponent={Transition}
                            keepMounted
                            onClose={() => this.handleClose('classicModal')}
                            aria-labelledby='classic-modal-slide-title'
                            aria-describedby='classic-modal-slide-description'
                          >
                            <DialogTitle
                              id='classic-modal-slide-title'
                              disableTypography
                              className={javascriptstyles.modalHeader}
                            >
                              <h4 className={javascriptstyles.modalTitle}>
                                Move Story To
                              </h4>
                            </DialogTitle>
                            <DialogContent
                              id='classic-modal-slide-description'
                              className={javascriptstyles.modalBody}
                            >
                              <div className='form-element movestory-element'>
                                <FormControl
                                  className={basicsStyle.formControl}
                                >
                                  <InputLabel htmlFor='movestory-element'>
                                    Sprint
                                  </InputLabel>
                                  <Select
                                    name='moveStory'
                                    fullWidth={false}
                                    value={moveStory}
                                    onChange={this.onChange}
                                  >
                                    <MenuItem value=''>
                                      <em>Select Sprint</em>
                                    </MenuItem>
                                    {sprintLists.map((option) => (
                                      <MenuItem value={option._id}>
                                        {option.title}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  <FormHelperText>
                                    Please select sprint
                                  </FormHelperText>
                                </FormControl>
                              </div>
                            </DialogContent>
                            <DialogActions
                              className={javascriptstyles.modalFooter}
                            >
                              <Button color='success' onClick={this.moveSprint}>
                                Move Story
                              </Button>
                              <Button
                                onClick={() => this.handleClose('classicModal')}
                                color='danger'
                                simple
                              >
                                Close
                              </Button>
                            </DialogActions>
                          </Dialog>
                        </GridItem>
                      </GridContainer>
                    </div>
                  </div>
                  <p>
                    <strong>Complexity: </strong> {val.complexity}
                  </p>
                  <p>
                    <strong>Acceptance Criteria: </strong>
                    <ul>
                      {_.map(val.criteria, (criteria_val, criteria_index) => {
                        return (
                          <li key={criteria_index}>{criteria_val.text}</li>
                        );
                      })}
                    </ul>
                  </p>
                </div>
              </div>
            );
          })}
          <hr />
          <Grid container justify='space-between'>
            <Link
              to={`/projects/${this.props.project._id}/sprints/${
                this.props.sprint._id
              }/`}
            >
              <Button
                type='button'
                color='success'
                round
                size='sm'
                className='custom-stepwizard-cancel-btn'
              >
                Back
              </Button>
            </Link>
            {this.props.sprint && this.props.sprint.status !== 'Complete' && (
              <div style={{ float: 'right', marginTop: '15px' }}>
                <Button color='success' onClick={this.onSubmitSprint} round>
                  Submit Sprint
                </Button>
              </div>
            )}
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  projectSavedData: state.project.projectSavedData,
  sprintSavedData: state.sprint.sprintSavedData,
  userStoriesSavedData: state.userStories.userStoriesSavedData,
  userStoriesList: state.userStories.userStoriesList,
  moveUserStoriesListResponse: state.userStories.moveUserStoriesListResponse,
  userStoryDeleteError: state.userStories.userStoryDeleteError,
});

const mapDispatchToProps = (dispatch) => ({
  updateSprint: (data, projectId, sprintId) =>
    dispatch(updateSprint(data, projectId, sprintId)),
  getUserStories: (projectId, sprintId) =>
    dispatch(getUserStories(projectId, sprintId)),
  setUserStoriesData: (data) => dispatch(setUserStoriesData(data)),
  loadSprintLists: (projectId) => dispatch(getAllSprintList(projectId)),
  moveUserStoryToAnotherSprint: (projectId, sprintId, storyId, newSprintId) =>
    dispatch(
      moveUserStoryToAnotherSprint(projectId, sprintId, storyId, newSprintId)
    ),
  deleteUserStory: (projectId, sprintId, storyId) =>
    dispatch(deleteUserStory(projectId, sprintId, storyId)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true }
  )(withStyles(style)(SprintInfo))
);
